import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Parents = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />

      <Sidebar
        isOpen={open}
        close={() => setOpen(false)}
      />

      <main className="page-wrapper">

        {/* HERO */}

        <div className="about-hero">

          <div className="about-overlay">

            <h1>PARENTS</h1>

            <Breadcrumb />

          </div>

        </div>


        {/* PAGE CONTENT */}

        <div className="container contact-page">

          <div className="vision-card parents-card">


            {/* HEADER */}

            <div className="parents-header">

              <h2>
                PARENT - TEACHER MEET
              </h2>

              <div className="parents-title-line"></div>

               <div className="awards-subtitle-wrap">
                    <span className="awards-subtitle-line"></span>

                    <p className="awards-subtitle">
                        Building Strong Partnerships for Student Success
                    </p>

                    <span className="awards-subtitle-line"></span>
                </div>

            </div>


            {/* INTRODUCTION */}

            <div className="parents-content">

              <p>
                At Nav Jeevan Mission School, Anandnagar, we believe
                that the active involvement of parents is an essential
                part of a child’s educational journey. Parent–Teacher
                Meetings (PTMs) provide a valuable opportunity for
                parents and teachers to communicate, share observations
                and work together for the overall development of every
                student.
              </p>


              {/* PTM PURPOSE */}

              <div className="parents-section">

                <div className="parents-section-heading">

                  <span className="parents-dot"></span>

                  <h3>
                    PTMs Help Us To
                  </h3>

                </div>


                <ul className="parents-list">

                  <li>
                    Discuss the academic progress and learning
                    outcomes of students.
                  </li>

                  <li>
                    Review attendance, discipline and regularity.
                  </li>

                  <li>
                    Identify individual strengths, talents and
                    areas requiring improvement.
                  </li>

                  <li>
                    Share feedback regarding students’ behaviour,
                    participation and classroom performance.
                  </li>

                  <li>
                    Discuss suitable strategies for academic and
                    personal development.
                  </li>

                  <li>
                    Strengthen communication and cooperation
                    between parents and teachers.
                  </li>

                  <li>
                    Encourage parents to actively participate in
                    their child’s education and overall growth.
                  </li>

                  <li>
                    Develop a strong school–home partnership for
                    the success of every student.
                  </li>

                </ul>

              </div>


              {/* COMMITMENT */}

              <div className="parents-commitment">

                <div className="parents-section-heading">

                  <span className="parents-dot"></span>

                  <h3>
                    Our Commitment
                  </h3>

                </div>


                <p>
                  We consider parents as valuable partners in
                  education. Through regular and meaningful
                  interaction, we work together to ensure that
                  every child receives the guidance, encouragement
                  and support needed to reach their full potential.
                </p>

              </div>


              {/* QUOTE */}

              <div className="parents-quote">

                <span className="parents-quote-open">
                  “
                </span>

                <p>
                  When parents and teachers work together,
                  children achieve more.
                </p>

                <span className="parents-quote-close">
                  ”
                </span>

              </div>


              {/* CLOSING */}

              <div className="parents-closing">

                <strong>
                  Nav Jeevan Mission School
                </strong>

                <span>
                  Together for Every Child’s Success.
                </span>

              </div>


            </div>

          </div>

        </div>

      </main>

      <Footer />
    </>
  );
};

export default Parents;